module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jNEzv"))).then(() => parcelRequire('1iHdE'));